export const speakingStarters = [
  "How was your day?",
  "Where do you want to travel?",
  "What are your plans for the weekend?",
  "What's your favorite food?",
  "Tell me about your hobbies",
  "What did you do today?",
  "Do you have any pets?",
  "What's your favorite movie?",
  "What music do you like?",
  "What do you do for fun?",
  "Where are you from?",
  "Do you have any siblings?",
  "What's your dream vacation?",
  "What's your favorite season?",
  "Do you like cooking?",
  "What did you eat today?",
  "Do you play any sports?",
  "What's your favorite book?",
  "Do you have any plans tonight?",
  "What makes you happy?",
  "What's your job?",
  "Do you like your work?",
  "What's your favorite restaurant?",
  "Do you prefer coffee or tea?",
  "What did you do last weekend?",
  "Do you like going to the beach?",
  "What's your favorite holiday?",
  "Do you enjoy reading?",
  "What languages do you speak?",
  "Do you like watching TV shows?",
  "What's your favorite sport?",
  "Do you exercise regularly?",
  "What's your morning routine?",
  "Do you have any goals this year?",
  "What time do you usually wake up?",
  "Do you like going to concerts?",
  "What's your favorite color?",
  "Do you enjoy shopping?",
  "What's something you're learning?",
  "Do you like trying new foods?",
  "What's your favorite dessert?",
  "Do you enjoy traveling?",
  "What's your favorite city?",
  "Do you have a favorite artist?",
  "What makes you laugh?",
  "Do you like meeting new people?",
  "What's something you're proud of?",
  "Do you prefer summer or winter?",
  "What's your ideal day like?",
  "Do you enjoy nature?"
];
